var exports = {
  "kR": "AssetSourceModal.module__cards___Vmp5N3",
  "KI": "AssetSourceModal.module__cardsSingle___Vmp5N3",
  "Nr": "AssetSourceModal.module__card___Vmp5N3",
  "Ie": "AssetSourceModal.module__cardIcon___Vmp5N3",
  "PY": "AssetSourceModal.module__cardLabel___Vmp5N3",
  "eX": "AssetSourceModal.module__cardHint___Vmp5N3",
};

module.exports = exports;
